import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { IntelligenceRangeModel } from './typings/intelligence.range';
import { IntelligenceService }    from './intelligence.service';

@Component({
  selector   : 'wor-intelligence-date-range-picker',
  template: require('./intelligence.date-range-picker.component.html')
})
export class DateRangePickerComponent implements OnInit {
  @Output() rangeChange = new EventEmitter<IntelligenceRangeModel>();

  activePreset = 'LAST_30';
  customEnd = '';
  customStart = '';
  presets = [ 'TODAY', 'THIS_WEEK', 'LAST_WEEK', 'LAST_30', 'THIS_MONTH', 'LAST_MONTH', 'YTD', 'CUSTOM' ];

  constructor (
    private intelligenceService: IntelligenceService
  ) {}

  ngOnInit () : void {
    this.customEnd = this.intelligenceService.range.end_date;
    this.customStart = this.intelligenceService.range.start_date;
  }

  applyCustom () : void {
    if ( !this.customStart || !this.customEnd || this.customStart > this.customEnd ) {
      return;
    }

    this.rangeChange.emit({
      end_date  : this.customEnd,
      start_date: this.customStart
    });
  }

  selectPreset ( preset : string ) : void {
    this.activePreset = preset;

    if ( preset === 'CUSTOM' ) {
      return;
    }

    const range = this.intelligenceService.presetRange(preset);

    this.customEnd = range.end_date;
    this.customStart = range.start_date;

    this.rangeChange.emit(range);
  }
}
